import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.bb{min-height:100vh;}.ssr-plugin'
import '.aj{background-color:var(--shades-white);}.ssr-plugin'
import '.s{padding:2rem;}.ssr-plugin'
import '.g{gap:2rem;}.ssr-plugin'
import '.f3{height:3rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="a e f b bb aj s g"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <img className="f3"
        src={fullLogo}
        alt="CrowdBuilding"
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
